import * as React from "react";
export const LiveTableBodyColumn = (props) => {
    return (React.createElement("td", { className: "rj-scoreboard__live-team-score", "data-uat": "scoreboard-live-team-score" }, props.value));
};
//# sourceMappingURL=LiveTableBodyColumn.js.map